export enum NFTTokenStandards {
  'CEP47' = 1,
  'CEP78' = 2,
  'CEP95' = 3,
}

export const MapNFTTokenStandardToName = {
  [NFTTokenStandards.CEP47]: 'CEP-47',
  [NFTTokenStandards.CEP78]: 'CEP-78',
  [NFTTokenStandards.CEP95]: 'CEP-95',
};
